var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditsRegisterLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 416,
    viewBox: "0 0 373 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.7273 19.0043C29.5219 37.8497 11.8369 61.5029 8.05934 91.6513C1.29109 145.668 23.8807 174.78 28.1428 211.189C32.4049 247.598 11.1063 268.402 2.60374 301.379C-4.0329 327.118 16.1727 370.603 47.4151 392.363C79.3937 414.636 110.64 422.353 156.322 403.814C204.493 384.265 214.856 330.456 251.382 301.964C294.098 268.642 326.018 286.504 357.337 242.546C379.345 211.655 378.105 131.279 336.615 93.0723C303.242 62.3413 261.639 71.3746 221.91 50.1989C181.404 28.6088 164.345 9.72659 142.261 4.44958C111.425 -2.91886 88.0442 3.60468 61.7273 19.0043Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditsRegisterLasso);
export default __webpack_public_path__ + "static/media/edits-register-lasso.2b23ef6fe4008a9e05a963c8ae92cbfe.svg";
export { ForwardRef as ReactComponent };